import "./styles.css";

import { useParams } from "react-router-dom";

import { useCommunity } from "@contexts/CommunityContext";

import Screen from "@components/Screen";
import { AltRouteRounded, AutoAwesomeRounded, DoNotDisturbAltRounded, KeyboardArrowRightRounded, LocalSeeRounded, LocationSearchingRounded, SavingsRounded, SellRounded, SettingsInputComponentRounded, SettingsRounded, TagRounded } from "@mui/icons-material";

import General from './tabs/General'
import Pricing from './tabs/Pricing'
import Coupons from './tabs/Coupons'
import Split from './tabs/Split'
import Pixel from './tabs/Pixel'

import { useEffect, useState } from "react";

import api from "@api";
import { CircularProgress } from "@mui/material";


export default function CommunityConfig() {
    let { tab, slug } = useParams();

    const { loading: communityLoading, community } = useCommunity();

    const [loadingCommunity, setLoadingCommunity] = useState(true);

    const [info, setInfo] = useState(null);


    const currentCommunity = community.getBySlug(slug);


    console.log('currentCommunity', currentCommunity, slug, community.getBySlug)

    const items = [
        {
            title: "Geral",
            subtitle: "Nome, descrição, links, etc",
            url: "general",
            icon: <AutoAwesomeRounded />,
            component: <General info={info} />,
            default: true
        },
        {
            title: "Precificação",
            subtitle: "Planos de assinatura",
            url: "pricing",
            icon: <SavingsRounded />,
            component: <Pricing info={info} />
        },
        {
            title: "Cupons de desconto",
            subtitle: "Gere cupons de desconto",
            url: "coupons",
            icon: <SellRounded />,
            component: <Coupons info={info} />
        },
        {
            title: "Split de pagamentos",
            subtitle: "Divida a receita entre recebedores",
            url: "split",
            icon: <AltRouteRounded />,
            component: <Split info={info} />
        },
        {
            title: "Pixel de conversão",
            subtitle: "Rastreie as vendas da sua comunidade",
            url: "pixel",
            icon: <LocationSearchingRounded />,
            component: <Pixel info={info} handleRefresh={() => setLoadingCommunity(true)} />
        }
    ]

    const current = items.filter(i => i.url === tab)[0] || items[0]

    const hasAccess = ['owner', 'admin', 'creator'].includes(currentCommunity?.role)

    useEffect(() => {
        if (loadingCommunity && currentCommunity?.id) {
            handleLoadCommunity();
        }
    }, [currentCommunity, loadingCommunity])


    async function handleLoadCommunity() {
        try {
            const { data } = await api.get(`/community?id=${currentCommunity.id}`);
            console.log('COmm load', data)
            if (data?.id) setInfo({ ...data })
        } catch (error) {
            console.log(error)
        }
        setLoadingCommunity(false)
    }

    function Loading() {
        return (
            <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                gap: "10px",
                height: "60vh",
                width: "100%"
            }}>
                <CircularProgress size={20} />
                <span>Carregando...</span>
            </div>
        )
    }

    return (
        <Screen
            fullWidth={true}
            className="config-community-page"
            title={[
                { title: "Configurar comunidade", iconLeft: <SettingsRounded fontSize="small" /> },
                { title: current.title }
            ]}>
            <div className="current-config-page">
                {
                    loadingCommunity ? <Loading /> : hasAccess && !loadingCommunity ? (
                        <>
                            <ConfigSidebar items={items} />
                            {
                                current.component || <></>
                            }
                        </>
                    ) : <NotFound />
                }
            </div>
        </Screen>
    );
}

function ConfigSidebar({ items }) {
    function SidebarButton({ title, subtitle, icon, url, component, ...props }) {
        let { slug, tab } = useParams();

        const isActive = tab === url || (props.default && !tab)

        return (
            <div
                style={{
                    opacity: component ? 1 : 0.4,
                    pointerEvents: component ? 'all' : 'none'
                }}
                className={"config-community-sidebar-btn " + (isActive && 'active')}
                onClick={() => window.navigate(slug + '/settings/' + url)}
            >
                <div className="ccsb-icon">
                    {icon}
                </div>
                <div className="ccsb-desc">
                    <h5>{title}</h5>
                    <small>{subtitle}</small>
                </div>
                <KeyboardArrowRightRounded />
            </div>
        )
    }

    return (
        <div className="config-community-sidebar">
            {
                items.map((item, index) => (
                    <SidebarButton
                        {...item}
                        key={index}
                    />
                ))
            }
        </div>
    )
}

function NotFound() {
    return (
        <div style={{
            width: "80%",
            display: "flex",
            height: '50vh',
            maxWidth: '500px',
            alignItems: 'center',
            textAlign: "center",
            margin: "0 auto",
            justifyContent: "center",
            flexDirection: "column",
            gap: "10px"
        }}>
            <DoNotDisturbAltRounded fontSize="large" />
            <h2>Comunidade não encontrada</h2>
        </div>
    )
}